// Product Card

class ProductCard {
  constructor() {
    const swatches = document.querySelectorAll('.swatch')
    const firstSwatches = document.querySelectorAll('.product-card__swatches')

    if (swatches.length > 0) {
      this.swatchToggles(swatches)
    }

    {firstSwatches &&
      firstSwatches.forEach(item => {
        const referenceSwatch = item.querySelector('.swatch--reference')

        {referenceSwatch &&
          setTimeout(() => {
            referenceSwatch.click()
          }, 200);
        }
      })
    }
  }

  swatchToggles(items) {

    items.forEach(swatch => {
      ['click', 'keypress'].forEach(event => {
        swatch.addEventListener(event, e => {
          const key = e.which || e.keyCode;
          if (key === 13 || e.type === 'click') {
            const parentContainer = swatch.parentNode;
            const containerLink = parentContainer.parentNode.previousElementSibling;
            const cardImage = containerLink.querySelector('.product-card__variant-image');
            const currentSwatches = parentContainer.querySelectorAll('.swatch');
            
            // TODO: REMOVE IF OLD PRODUCT CARD RULES WILL REMAIN IN USE
            const cardPrice = parentContainer.parentNode.querySelector('.product-card__meta__price');
            const cardOriginalPrice = parentContainer.parentNode.querySelector('.product-card__meta__original-price');
            const cardSalePercentage = parentContainer.parentNode.querySelector('.product-card__meta__percentage');

            [].forEach.call(currentSwatches, function (el) {
              el.classList.remove('current')
            });

            swatch.classList.add('current')

            // CARD IMAGE UPDATE
            cardImage.querySelector('img').src = swatch.dataset.img
            cardImage.classList.remove('hidden')

            // TODO: REMOVE IF OLD PRODUCT CARD RULES WILL REMAIN IN USE
            // CARD PRICING UPDATE
            // cardPrice.innerHTML = swatch.dataset.price
            // if (swatch.dataset.comparePrice && swatch.dataset.comparePrice !== '$0') {
            //   cardOriginalPrice.innerHTML = swatch.dataset.comparePrice
            //   cardSalePercentage.innerHTML = Math.floor(100 - (100 * Math.abs(swatch.dataset.price.replace('$', '')/swatch.dataset.comparePrice.replace('$', '')))) + '% off'
            //   cardOriginalPrice.classList.remove('visually-hidden')
            //   cardSalePercentage.classList.remove('visually-hidden')
            // } else {
            //   cardOriginalPrice.classList.add('visually-hidden')
            //   cardSalePercentage.classList.add('visually-hidden')
            // }

            // CARD BADGING UPDATE
            if (swatch.dataset.badging) {
              let cardBadge = containerLink.previousElementSibling.querySelector('.product-card__badge--standard')
              
              cardBadge.innerHTML = swatch.dataset.badging
              cardBadge.classList.remove('visually-hidden')
            } else {
              let cardBadge = containerLink.previousElementSibling.querySelector('.product-card__badge--standard')

              cardBadge.classList.add('visually-hidden')
            }

            if (swatch.dataset.calloutBadging) {
              let cardCalloutBadge = containerLink.previousElementSibling.querySelector('.product-card__badge--callout')

              cardCalloutBadge.innerHTML = swatch.dataset.calloutBadging
              cardCalloutBadge.classList.remove('visually-hidden')
            } else {
              let cardCalloutBadge = containerLink.previousElementSibling.querySelector('.product-card__badge--callout')
              
              cardCalloutBadge.classList.add('visually-hidden')
            }

            containerLink.href = swatch.dataset.url
          }
        });
      });
    });
  }
}

const productCardInit = {
  init() {
    // if element exists init this class
    const wrapperEl = document.querySelector('.product-card');
    if (wrapperEl !== null) {
      // eslint-disable-next-line no-unused-vars
      new ProductCard(wrapperEl);
    }
  },
};

export default productCardInit;
